import ProjectSession from "../../../../../core/model2/project/project-session"
import {QuickAddItemType} from "../../../../../app/quick-add/@types"
import {PopoverMenuItemType} from "../../../../../core/gd-components/popover-menu/popover-menu/const"
import newProject_getMyTemplates from "../../../../../app/quick-add/sections/project/helper/get-my-templates"
import menuAdd_getProjectTemplates from "./get-project-templates"
import {NavigationMenuInlineAddParams, NavigationMenuInlineAddType} from "../@types"

// const debug = "navigationMenuAdd_initFolder"
const debug = false

type Params = {
    projectId?  : ID
    project?    : ProjectSession
    disabled    : boolean
    hidePopover : func
    onAddInline : {(inlineAddType: NavigationMenuInlineAddType, params?: NavigationMenuInlineAddParams):void}
}

export default function navigationMenuAdd_initFolder(options:Options, params:Params) {

    const onAddSubproject = (templateId: ID) => {
        debug && console.log(debug, 'onAddSubproject', params.projectId, templateId)

        gd.openNew(QuickAddItemType.PROJECT, {
            company     : gd.companyId,
            projectId   : params.projectId,
            templateId  : templateId,
        })
        params.hidePopover()
    }

    const onAddFromLibrary = () => {
        debug && console.log(debug, 'onAddFromLibrary')

        gd.openNew(QuickAddItemType.PROJECT, {
            company             : gd.companyId,
            projectId           : params.projectId,
            templatesLibrary    : true
        })
        params.hidePopover()
    }

    const onAddGroup = () => {
        params.onAddInline(NavigationMenuInlineAddType.GROUP)
        gd.layout.popovers.closeAll()
    }

    const onAddEmptyFolder = () => {
        params.onAddInline(NavigationMenuInlineAddType.FOLDER, {isEmpty: true})
    }

    const isRootFolder = !params.project || params.project.isWorkspace || params.project.isSection

    // Root level can't inherit views, so only a plain "Folder" is offered there
    const folderOptions = isRootFolder
        ? [
            {
                icon    : 'i5-folder',
                label   : 'Folder',
                hint    : 'Create an empty folder',
                onClick : onAddEmptyFolder
            }
        ]
        : [
            {
                icon    : 'i5-inherited-folder',
                label   : 'Folder',
                hint    : 'Create a folder and inherit views from its parent folder.',
                onClick : ()=>{params.onAddInline(NavigationMenuInlineAddType.FOLDER)}
            },
            {
                icon    : 'i5-folder',
                label   : 'Empty Folder',
                hint    : 'Create an empty folder',
                onClick : onAddEmptyFolder
            }
        ]

    const projectTemplatesOptions = menuAdd_getProjectTemplates(newProject_getMyTemplates(), onAddSubproject, onAddFromLibrary)

    options.push({
        type    : PopoverMenuItemType.SUBMENU,
        icon    : 'i5-folder',
        label   : 'Folder / Project',
        disabled: params.disabled,
        options : [
            ...folderOptions,
            {
                icon    : "i5-group",
                disabled: params.disabled,
                label   : "Group",
                hint    : 'Create a group to organize projects, folders and views together in the tree.',
                onClick : onAddGroup
            },
            {
                type    : PopoverMenuItemType.SEPARATOR,
            },
            {
                type    : PopoverMenuItemType.HEADER,
                label   : "Templates"
            },

            ...projectTemplatesOptions
        ]
    })
}
